import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { defaultIfEmpty, map, take } from 'rxjs';
import { ToastService } from '@shared/toast';
import { erreurPersistante } from '../toast/erreur-persistante';
import { possedeUnRoleParmi, RolesUtilisateurService } from '../components/login/roles-utilisateur.service';

// À placer APRÈS MsalGuard dans canActivate : attend le chargement des rôles (token +
// API) puis n'autorise la route que si l'utilisateur porte au moins un des rôles attendus.
// Prend de préférence un ensemble de RolesAcces, pour que la route et le menu latéral
// s'appuient sur la même règle. Si le chargement précédent a échoué, rolesFrais$ retente
// un fetch : une navigation suffit à récupérer, sans rechargement de page
export const rolesGuard = (...rolesAutorises: readonly string[]): CanActivateFn => {
  return () => {
    const rolesUtilisateurService = inject(RolesUtilisateurService);
    const toast = inject(ToastService);
    const router = inject(Router);

    return rolesUtilisateurService.rolesFrais$().pipe(
      take(1),
      // Filet de sécurité : une complétion sans valeur laisserait la navigation en suspens
      defaultIfEmpty([] as string[]),
      map(roles => {
        if (possedeUnRoleParmi(roles, rolesAutorises)) {
          return true;
        }

        // Refus faute de droits chargés : le dire, sinon la redirection est indiscernable
        // d'un accès légitimement refusé
        if (!rolesUtilisateurService.rolesCharges()) {
          /* Persistante : un refus d'acces faute de droits charges doit rester
             lisible le temps que l'utilisateur agisse. */
          erreurPersistante(toast, 'Vos droits n’ont pas pu être chargés. Rechargez la page ou contactez le support.');
        }

        return router.createUrlTree(['/home']);
      }),
    );
  };
};
